// extracted by extract-css-chunks-webpack-plugin
module.exports = {"paymentPayoutGroup":"Gy3Urv","headerInfo":"_3tVJPb","infoBtn":"_1h55EX","paymentPayoutTitle":"_2chE3g"};